import { flatten, filter, map, pathOr, find, equals, head } from "ramda";
import { isNotEmpty } from "src/utilities/hasValue";

export class PipeLineFilterByFinancials {

    getPodConfigSearchParams(podConfigs: any): any{
        return flatten(filter(isNotEmpty, map((pod) => {
            return this.pipeLineRuleConfigs(pathOr([], ['rule', 'rules'], pod))
        }, podConfigs)));
    }

    private pipeLineRuleConfigs(rules: any) {
        const productTypes = pathOr([], ['api_resource_path_value'], find((item: any) => equals('property_loan_type', pathOr('', ['varmap_name'], item)), rules));
        const loanAmount = head(pathOr([], ['api_resource_path_value'], find((item: any) => equals('mortgage_loan_amount', pathOr('', ['varmap_name'], item)), rules)));
        const result = filter(isNotEmpty, map((productType: any) => this.pipeLineRuleConfig(productType, loanAmount), productTypes));
        return result
    }

    private pipeLineRuleConfig(productType: any, loanAmont: any) {
        if (isNotEmpty(productType) && isNotEmpty(loanAmont)) {
            const result = {
                'product_type': productType,
                'loan_amount': {
                    min: '0',
                    max: `${pathOr('1000000000000', ['max'], loanAmont)}`
                }
            }
            return result;
        }
        return {}
    }
}

